export default __webpack_public_path__ + "static/media/26.52062026.png";